import { bindKeymapArrayWithCommand, bindKeymapWithCommand, moveLeft, moveRight, selectColumn, selectRow, selectTable, shiftArrowUp } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { arrowLeftFromTable, arrowRightFromTable, modASelectTable, selectColumns, selectRows, shiftArrowUpFromTable } from '../commands/selection';
export function tableSelectionKeymapPlugin(editorSelectionAPI) {
  var list = {};
  bindKeymapWithCommand(moveRight.common, arrowRightFromTable(editorSelectionAPI)(), list);
  bindKeymapWithCommand(moveLeft.common, arrowLeftFromTable(editorSelectionAPI)(), list);
  if (getBooleanFF('platform.editor.a11y.table-selection_9uv33')) {
    bindKeymapArrayWithCommand(selectColumn, selectColumns(editorSelectionAPI)(true), list);
    bindKeymapArrayWithCommand(selectRow, selectRows(editorSelectionAPI)(true), list);
  }
  if (getBooleanFF('platform.editor.table.shift-arrowup-fix')) {
    bindKeymapWithCommand(shiftArrowUp.common, shiftArrowUpFromTable(editorSelectionAPI)(), list);
  }
  if (getBooleanFF('platform.editor.table.cmd-a-select-table')) {
    bindKeymapWithCommand(selectTable.common, modASelectTable(editorSelectionAPI)(), list);
  }
  return keymap(list);
}
export default tableSelectionKeymapPlugin;